import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './GroupOrderDetail.less';

export default class GroupOrderDetail extends OfficialPage {
  state = {
    list: {},
    more_members_arr: [],
    orderId: ''
  }

  constructor(props) {
    super(props);
    document.title = '拼团详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let _this = this
    _this.setData({
      orderId: options.id || '',
      franchisee: options.franchisee || ''
    })
    _this.getOrderInfo()
  }

  getOrderInfo = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppGroupBuy/GetGroupBuyOrderInfo',
      data: {
        order_id: _this.data.orderId,
        sub_app_id: _this.data.franchisee
      },
      success: function(res) {
        let data = res.data
        let remark = data.form_data.remark
        let more_members_arr = []
        let max_user_num = Number(
          data.form_data.group_buy_order_info.max_user_num
        )
        let length = 0
        if (max_user_num <= 5) {
          length =
            max_user_num -
            data.form_data.group_buy_order_info.team_member_list.length
          for (let i = 0; i < length; i++) {
            more_members_arr.push('')
          }
        } else {
          length =
            3 - data.form_data.group_buy_order_info.team_member_list.length
          for (let i = 0; i < length; i++) {
            more_members_arr.push('')
          }
        }
        data.form_data.remark = remark
          ? remark.replace(/\n|\\n/g, '\n')
          : remark
        _this.setData({
          list: data,
          more_members_arr: more_members_arr
        })
      }
    })
  }
  onShareAppMessage = e => {
    let that = this,
      goodsInfo = this.data.list.form_data.goods_info[0],
      teamToken = this.data.list.form_data.team_token,
      id = e.from == 'button' ? e.target.dataset.detail : goodsInfo.goods_id,
      franchisee = this.data.franchisee,
      url =
        '/joinGroupDetail?detail=' +
        goodsInfo.goods_id +
        '&teamToken=' +
        teamToken +
        (franchisee ? '&franchisee=' + franchisee : '') +
        (app.globalData.pageShareKey
          ? '&psid=' + app.globalData.pageShareKey
          : ''),
      title =
        app.getUserInfo('nickname') +
        ' 喊你拼单啦~ ' +
        goodsInfo.price +
        '元拼' +
        goodsInfo.goods_name +
        '，火爆抢购中......'
    return app.shareAppMessage({
      title: title,
      path: url,
      imageUrl:
        'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
      success: function(addTime) {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: { add_time: addTime },
          success: function(res) {
            if (res.status == 0) {
              res.data &&
              that.setData({
                rewardPointObj: {
                  showModal: true,
                  count: res.data,
                  callback: ''
                }
              })
            }
          }
        })
      }
    })
  }
  pay = e => {
    let _this = this
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: e.target.dataset.id,
    //     sub_shop_app_id: _this.data.franchisee
    //   },
    //   success: function(res) {
    //     var param = res.data,
    //       orderId = e.target.dataset.id
    //     param.orderId = orderId
    //     param.goodsType = e.target.dataset.type
    //     param.success = function() {
    //       setTimeout(function() {
    //         let franchiseeParam = _this.data.franchisee
    //           ? '&franchisee=' + _this.data.franchisee
    //           : ''
    //         app.turnToPage(
    //           '/groupOrderDetail?id=' +
    //           orderId +
    //           franchiseeParam
    //         )
    //       }, 1500)
    //     }
    //     app.wxPay(param)
    //   }
    // })
    let franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '';
    let path = '/groupOrderDetail?id=' + orderId + franchiseeParam;
    app.goPay({
      orderId: orderId,
      successUrl: path
    });
  }
  retrieveMoney = e => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/ComfirmRefund',
      data: {
        order_id: e.target.dataset.id,
        sub_shop_app_id: _this.data.franchisee
      },
      success: function(data) {
        if (data.status === 0) {
          Taro.showToast({
            title: '确认成功'
          })
          _this.getOrderInfo()
          app.globalData.myGroupRefresh = true
        }
      }
    })
  }
  onceMore = e => {
    let id = e.currentTarget.dataset.id
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/groupGoodsDetail?detail=' + id + franchiseeParam
    )
  }
  goToOrderDetail = () => {
    app.turnToPage('/myOrder')
  }

  render() {
    const {
      list,
      more_members_arr
    } = this.state
    return (
      <div className="official-page group-order-detail">
        <TopNav title="拼团详情" />
        {list.form_data && (
          <React.Fragment>
            <div className="order-status">
              <div
                style={convertLineStyleData('margin-bottom:20rpx;')}
                hidden={!(list.form_data.group_buy_order_info.current_status == 1)}
              >
                未开团
              </div>
              <div
                style={convertLineStyleData('margin-bottom:20rpx;')}
                hidden={!(list.form_data.group_buy_order_info.current_status == 2)}
              >
                拼团中
              </div>
              <div
                style={convertLineStyleData('margin-bottom:20rpx;')}
                hidden={!(list.form_data.group_buy_order_info.current_status == 3)}
              >
                拼团成功
              </div>
              <div
                style={convertLineStyleData('margin-bottom:20rpx;')}
                hidden={!(list.form_data.group_buy_order_info.current_status == 4)}
              >
                拼团失败
              </div>
              <div
                style={convertLineStyleData('margin-bottom:20rpx;')}
                hidden={!(list.form_data.group_buy_order_info.current_status == 5)}
              >
                拼团结束
              </div>
              <div style={convertLineStyleData('font-size:26rpx;')}>
                {'团号：' + list.form_data.team_token}
              </div>
            </div>
            <div className="contact-info container">
              <div className="ico-moon icon-location"></div>
              <div className="detail-info">
                <div className="address">
                  {list.form_data.is_self_delivery != 1
                    ? '配送地址：' +
                    list.form_data.address_info.province.text +
                    list.form_data.address_info.city.text +
                    list.form_data.address_info.district.text +
                    list.form_data.address_info.detailAddress
                    : '自提地址：' + list.form_data.self_delivery_info.address}
                </div>
                <div className="address">
                  {'联系人：' +
                  (list.form_data.is_self_delivery != 1
                    ? list.form_data.address_info.name
                    : list.form_data.self_delivery_info.contact_name)}
                </div>
                <div className="address">
                  {'联系电话：' +
                  (list.form_data.is_self_delivery != 1
                    ? list.form_data.address_info.contact
                    : list.form_data.self_delivery_info.contact_phone)}
                </div>
              </div>
            </div>
            <div className="contact-info container">
              <div className="ico-moon icon-comment"></div>
              <div className="detail-info">
                <div className="address">买家留言</div>
                <div className="address">
                  <span>{list.form_data.remark}</span>
                </div>
              </div>
            </div>
            <div className="container order-detail">
              <div className="order-id">
                {'订单号：' + list.form_data.order_id}
              </div>
              <div className="goods-wrap">
                <img src={list.form_data.goods_info[0].cover} />
                <div className="price">
                  <div className="space-between">
                    <div className="goods-name text-overflow">
                      {list.form_data.goods_info[0].goods_name}
                    </div>
                    <div className="pay-price">
                      {'¥' + list.form_data.goods_info[0].original_price}
                    </div>
                  </div>
                  <div className="origin-price">
                    {'拼团(-¥' +
                    list.form_data.group_buy_order_info.discount_price +
                    ')'}
                  </div>
                  <div className="space-between">
                    <div className="goods-spec text-overflow">
                      {list.form_data.goods_info[0].model_value}
                    </div>
                    <div className="num">
                      {'x' + list.form_data.goods_info[0].num}
                    </div>
                  </div>
                </div>
              </div>
              <div className="discount">
                <div className="content">
                  <div className="ico-moon icon-group-pay"></div>
                  {'储值金：' + list.form_data.use_balance}
                </div>
                <div className="content">
                  <div className="ico-moon icon-coupon"></div>
                  {'优惠方式：' + list.form_data.selected_benefit.title}
                </div>
              </div>
              <div className="order-info">
                {'共' + list.form_data.goods_info[0].num + '件商品 实付：'}
                <span className="red-price">
              {'¥' + list.form_data.total_price}
            </span>
                {'(含运费¥' + list.express_fee + ')'}
              </div>
              <div
                className="progress"
                hidden={
                  list.form_data.group_buy_order_info.team_member_list.length === 0
                }
              >
                <div className="title">拼团进度：</div>
                <div className="head-logo">
                  <div className="group-leader">
                    <img
                      src={
                        list.form_data.group_buy_order_info.team_member_list[0]
                          .thumb
                      }
                    />
                    <div className="tag">团长</div>
                  </div>
                  {list.form_data.group_buy_order_info.max_user_num <= 5 && (
                    <div className="group-number">
                      {list.form_data.group_buy_order_info.team_member_list.map(
                        (item, index) => {
                          return (
                            <img
                              key={index}
                              hidden={index === 0}
                              className="members"
                              src={item.thumb}
                            />
                          )}
                      )}
                      {more_members_arr.map((item, index) => {
                        return (
                          <div key={index} className="more-members">
                            ?
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {list.form_data.group_buy_order_info.max_user_num > 5 && (
                    <div className="group-number">
                      {list.form_data.group_buy_order_info.team_member_list.map(
                        (item, index) => {
                          return (
                            <img
                              key={index}
                              className="members"
                              hidden={index === 0 || index > 2}
                              src={item.thumb}
                            />
                          )
                        }
                      )}
                      {more_members_arr.map((item, index) => {
                        return (
                          <div key={index} className="more-members">
                            ?
                          </div>
                        )
                      })}
                      <div className="omit">...</div>
                      {list.form_data.group_buy_order_info.team_member_list.length <
                      list.form_data.group_buy_order_info.max_user_num && (
                        <div className="more-members">?</div>
                      )}
                      {list.form_data.group_buy_order_info.team_member_list
                        .length ==
                      list.form_data.group_buy_order_info.max_user_num && (
                        <img
                          className="members"
                          src={
                            list.form_data.group_buy_order_info.team_member_list[
                            list.form_data.group_buy_order_info.max_user_num - 1
                              ].thumb
                          }
                        />
                      )}
                    </div>
                  )}
                </div>
                <div className="total-mumber">
                  已拼
                  <span className="red-price">
              {list.form_data.group_buy_order_info.current_user_count}
              </span>
                  人，还差
                  <span className="red-price">
              {list.form_data.group_buy_order_info.max_user_num -
              list.form_data.group_buy_order_info.current_user_count}
              </span>
                  人成团
                </div>
              </div>
              <div className="group-info">
                <div className="centent">
                  {'下单时间：' + list.form_data.add_time}
                </div>
                <div className="centent">
                  {'拼团人数：' +
                  list.form_data.group_buy_order_info.max_user_num +
                  '人团'}
                </div>
                <div className="centent">
                  {'拼团时限：' +
                  list.form_data.group_buy_order_info.hour_of_duration +
                  '小时' +
                  list.form_data.group_buy_order_info.minute_of_duration +
                  '分钟'}
                </div>
                <div
                  className="centent"
                  hidden={
                    !(list.form_data.group_buy_order_info.current_status == 3)
                  }
                >
                  {'结束时间：' + list.form_data.group_buy_order_info.expired_time}
                </div>
                <div
                  className="centent"
                  hidden={
                    !(list.form_data.group_buy_order_info.current_status == 3)
                  }
                >
                  {'成功时间：' + list.form_data.group_buy_order_info.success_time}
                </div>
              </div>
            </div>
            <div
              className="group-btn"
              hidden={!(list.form_data.group_buy_order_info.current_status == 1)}
            >
              <div className="btn white hide">取消拼团</div>
              <div
                className="btn red"
                data-id={list.form_data.order_id}
                data-type={list.form_data.goods_type}
                onClick={this.pay}
              >
                立即支付
              </div>
            </div>
            <div
              className="group-btn"
              hidden={!(list.form_data.group_buy_order_info.current_status == 2)}
            >
              <button
                className="btn red"
                openType="share"
                data-detail={list.form_data.goods_info[0].goods_id}
                onClick={this.shareClickEvent}
              >
                分享
              </button>
            </div>
            <div
              className="group-btn"
              hidden={!(list.form_data.group_buy_order_info.current_status == 3)}
            >
              <div
                className="btn white"
                style={convertLineStyleData('color:#000;')}
                onClick={this.goToOrderDetail}
              >
                查看订单
              </div>
              <div
                className="btn yellow"
                data-id={list.form_data.goods_info[0].goods_id}
                onClick={this.onceMore}
              >
                再拼一次
              </div>
            </div>
            <div
              className="group-btn"
              hidden={!(list.form_data.group_buy_order_info.current_status == 4)}
            >
              <div
                className="btn white"
                data-id={list.form_data.order_id}
                onClick={this.retrieveMoney}
                hidden={list.form_data.group_buy_order_info.current_status == 7}
              >
                已收到退款
              </div>
              <div
                className="btn yellow"
                data-id={list.form_data.goods_info[0].goods_id}
                onClick={this.onceMore}
              >
                再拼一次
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/group-order-detail/GroupOrderDetail.jsx